var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LTileLayer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}})
}
var staticRenderFns = []

export { render, staticRenderFns }